import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './DatapointsExportModalFooter.scss';

function DatapointsExportModalFooter({ applyDatapoints, cancelDatapoints }) {
  return (
    <div className="exportModal__footer datapointsExportModal__footer">
      <ButtonWithIcon
        data-e2e="export-modal-cancel"
        type="tertiary"
        size="small"
        sprite="Close"
        iconRight
        onClick={cancelDatapoints}
        className="e2e-export-modal-cancel">
        Cancel
      </ButtonWithIcon>

      <ButtonWithIcon
        data-e2e="export-modal-add-datapoints"
        type="secondary"
        size="small"
        sprite="ChevronRight"
        iconRight
        onClick={applyDatapoints}
        className="u-els-margin-left-1o2 e2e-export-modal-apply">
        Add datapoints
      </ButtonWithIcon>
    </div>
  );
}

DatapointsExportModalFooter.propTypes = {
  applyDatapoints: PropTypes.func.isRequired,
  cancelDatapoints: PropTypes.func.isRequired,
};

export default DatapointsExportModalFooter;
